import React from "react";
import { connect } from "react-redux";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { RouteComponentProps } from "react-router-dom";
import { client } from "../../../shared/apiClient";
import Header from "../../Common/Header";
import { iRootState } from "../../../store";

// @ts-ignore
import { getCurUser } from "cwb-react";
import AlertMessage from "../../Modals/AlertMessage";
import ThumbImg from "../../../images/cwb-thumb-img.svg";
import { StyledWhiteBtn } from "../../../helpers/styles";
import { IKioskCustomizationDto } from "../../../shared/dto/IKioskDto";
import Spinner_Blue from "../../../images/spinner_blue.svg";

interface IState {
  file: any;
  imageLogo: string;
  showDelete: boolean;
  imageDeleted: boolean;
  isLoading: boolean;
}

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
}

class KioskManagement extends React.Component<IProps, {}> {
  inputElement: any = null;

  public state: IState = {
    file: "",
    imageLogo: this.props.kioskLogo || "",
    showDelete: false,
    imageDeleted: false,
    isLoading: false,
  };

  async componentWillMount() {
    this.setState({
      isLoading: true,
    });
    await this.props.getKioskCustomizationInfo();
    this.setState({
      isLoading: false,
    });
  }

  handleImageChange = (e: any) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      if (file["type"].split("/")[0] === "image") {
        this.setState({
          file: file,
          imageLogo: reader.result,
          showDelete: false,
          imageDeleted: false,
        });
      } else {
        this.props.showAlert("error", this.props.t("Only image accepted."));
      }
    };

    reader.readAsDataURL(file);
  };

  handleSave = () => {
    this.props.saveKioskManagementInfo(this.state.file);
  };

  render() {
    const { kioskLogo, t } = this.props;
    const { imageLogo, showDelete } = this.state;

    const breadCrumbList = [
      {
        label: t("Scheduling"),
        to: `${client.api.paths.domain}/castingworkbook/directors/schedulelist.asp`,
      },
      { label: t("Kiosk"), to: "/", relative: true },
      { label: t("Kiosk Management") },
    ];

    return (
      <Wrapper>
        <AlertMessage {...this.props} />
        <Header
          title={t("Kiosk Management")}
          breadCrumbList={breadCrumbList}
        ></Header>
        <ContentBox>
          <ContentHeader>
            <ContentTitle>{t("Upload Logo")}</ContentTitle>
          </ContentHeader>

          <UploadWrapper>
            {this.state.isLoading && (
              <StyledSpinner
                src={Spinner_Blue}
                alt=""
                style={{ marginLeft: "10px", marginRight: "25px" }}
              />
            )}
            {!this.state.isLoading && this.props.kioskCustomizationInfo && (
              <>
                {!imageLogo && !kioskLogo && (
                  <StyledUploadDiv onClick={() => this.inputElement.click()}>
                    <StyledThumbImg src={ThumbImg} />
                    <input
                      type="file"
                      ref={(input) => (this.inputElement = input)}
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={this.handleImageChange}
                    />
                  </StyledUploadDiv>
                )}
                {(imageLogo || kioskLogo) && (
                  <StyledUploadDiv
                    className={`${imageLogo || kioskLogo ? "uploaded" : ""}`}
                    onMouseEnter={() => this.setState({ showDelete: true })}
                    onMouseLeave={() => this.setState({ showDelete: false })}
                  >
                    {showDelete && (
                      <i
                        className="icon-cwb-delete"
                        onClick={() => {
                          this.props.setKioskLogo(null);
                          this.setState({
                            file: "",
                            imageLogo: "",
                            imageDeleted: true,
                          });
                        }}
                      />
                    )}
                    <StyledPreviewImg
                      src={imageLogo || kioskLogo}
                      style={{ opacity: showDelete ? 0.1 : 1 }}
                    />
                  </StyledUploadDiv>
                )}
              </>
            )}
            <div>
              <div style={{ fontSize: "14px", fontWeight: 600 }}>
                <i className="icon-cwb-upload mr-2" />
                {t("Upload your logo")}
              </div>
              <div>
                {t("Click the upload box to the left and upload a new logo")}
              </div>
            </div>
          </UploadWrapper>

          <FooterWrapper>
            <StyledWhiteBtn
              disabled={
                this.state.imageDeleted ||
                this.state.showDelete ||
                !this.state.imageLogo
              }
              style={{ width: "120px", height: "36px", fontSize: "14px" }}
              onClick={this.handleSave}
            >
              {t("Save")}
            </StyledWhiteBtn>
            <div style={{ fontSize: "14px" }}>
              {t("Your Kiosk URL is")}:&nbsp;
              <PreviewLink
                href={`//${client.api.paths.domain}/facilitylogin.asp?kid=${
                  getCurUser().id.userId
                }`}
                target="_blank"
              >
                {`https:${client.api.paths.domain}/facilitylogin.asp?kid=${
                  getCurUser().id.userId
                }`}
              </PreviewLink>
            </div>
          </FooterWrapper>
        </ContentBox>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: ${(p) => p.theme.kiosk.backgroundColor};

  .cwb-table-wrapper {
    max-width: 1040px;
    border: 1px solid #e7e7f0 !important;
    box-shadow: 0 2px 4px 0 #e0e0e0 !important;
    border-radius: 4px;
  }
`;

const StyledSpinner = styled.img`
  width: 60px !important;
  min-height: 60px;
  height: auto;
`;

const ContentBox = styled.div`
  width: 100%;
  min-height: 70vh;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 40px auto;
  overflow-x: auto;
  overflow-y: hidden;
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-right: 2px;
`;

const ContentTitle = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
`;

const UploadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${(p) => p.theme.white};
  padding: 24px;
  border: 1px solid #e7e7f0 !important;
  box-shadow: 0 2px 4px 0 #e0e0e0 !important;
  border-radius: 4px;
`;

const StyledUploadDiv = styled.div`
  box-sizing: border-box;
  height: 87px;
  width: 87px;
  border: ${(p) => p.theme["border-3"]};
  border-radius: 4px;
  background-color: #f4f5f7;
  box-shadow: 0 4px 6px 0 #f6f6f6;
  margin-right: 24px;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &.uploaded {
    position: relative;
    border: 0;
    cursor: default;
    i.icon-cwb-delete {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
      z-index: 99;
    }
  }
`;

const StyledThumbImg = styled.img`
  height: 40px;
  width: 40px;
  border: 2px solid #d1d5dd;
  border-radius: 4px;
`;

const StyledPreviewImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  border: ${(p) => p.theme["border-3"]};
  border-radius: 4px;
  background: ${(p) => p.theme.white};
`;

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
`;

const PreviewLink = styled.a`
  &&&,
  &.hover {
    color: ${(p) => p.theme.grey};
    font-size: ${(p) => p.theme["xs-font-size"]};
    font-weight: ${(p) => p.theme["font-weight-600"]};
    line-height: 18px;
    i {
      position: relative;
      right: 6px;
      top: 1px;
      text-decoration: none !important;
    }
  }
`;

interface StateProps {
  kioskLogo: string;
  kioskCustomizationInfo: IKioskCustomizationDto;
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    kioskLogo: state.kiosk.kioskLogo,
    kioskCustomizationInfo: state.kiosk.kioskCustomizationInfo,
  };
}

interface DispatchProps {
  showAlert: (type: string, message: "string") => void;
  saveKioskManagementInfo: (file: any) => void;
  getKioskCustomizationInfo: () => void;
  setKioskLogo: (logo: string) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    showAlert: dispatch.alert.showAlert,
    saveKioskManagementInfo: dispatch.kiosk.saveKioskManagementInfo,
    getKioskCustomizationInfo: dispatch.kiosk.getKioskCustomizationInfo,
    setKioskLogo: dispatch.kiosk.setKioskLogo,
  };
}

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(KioskManagement)
);
